import { Instagram, ArrowUp } from "lucide-react";
import { NAV_LINKS, CONTACT, scrollToId } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-royal text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div>
            <img src="/assets/logo-white.png" alt="Creative" className="h-10 w-auto" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/60">
              Agência criativa: estratégia, marketing, design, fotografia e vídeo.
            </p>
          </div>

          <nav className="flex flex-col gap-3" data-testid="footer-links">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => scrollToId(l.href)}
                className="text-left text-sm font-semibold text-white/70 transition-colors duration-300 hover:text-white"
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </button>
            ))}
            <a
              href={CONTACT.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm font-semibold text-white/70 transition-colors duration-300 hover:text-white"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-4 w-4" />
              Instagram
            </a>
          </nav>

          <button
            onClick={() => scrollToId("#topo")}
            className="group flex h-12 w-12 items-center justify-center self-start rounded-full border border-white/25 text-white transition-all duration-500 hover:bg-white hover:text-royal-deep"
            data-testid="footer-back-to-top"
            aria-label="Voltar ao topo"
          >
            <ArrowUp className="h-5 w-5 transition-transform duration-500 group-hover:-translate-y-1" />
          </button>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/50">
          <span>© 2026 Creative. Todos os direitos reservados.</span>
          <span className="font-display italic">Estratégia + Criatividade, juntas.</span>
        </div>
      </div>
    </footer>
  );
}
